import React from "react";
import BilateralSearch from "../../../../Components/BilateralSearch/BilateralSearch";

const Consumer_Generator_Search = () => {
  return (
    <div style={{ height: "100%", width: "100%" }}>
      <BilateralSearch />
    </div>
  );
};

export default Consumer_Generator_Search;
